import React, {Component} from 'react';
import * as func from "../../../utils/functions";
import ReactPaginate from "react-paginate";
import {objectToQueryString, pushUrl} from "../../../utils/functions";
import {BASE_PATH, IMPORT_STATUS_NAME} from "../../../wpconfig";

class WosForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isInit : false,
			param : {
				'type' : 'wos',
				'uploadType' : 'excel',
				'current_page': 1,
				'record_per_page': 10,
			},
			records : [],
			totalRecords : 0,
			totalPage : 0,
			format : [
				{"value": "excel", "name": "Excel"},
				// {"value": "tab", "name": "탭으로 구분된 형식(Win, UTF-8)"}
			],
			action : 'admin/import/',
		}

		this.submit = this.submit.bind(this)
	}

	componentDidMount() {
		let param = this.state.param
		if (location.search.substring(1)) {
			param = func.parseParams(location.search.substring(1))
			delete param.page
			param.type = 'wos'
			param.uploadType = 'excel'
		}

		func.getData(this.state.action + 'list', param).then((response) => {
			// console.log(response)
			if(response) {
				this.setState({
					isInit : true,
					records : response.records,
					totalPage : response.pageInfo.totalPage,
					totalRecords : response.pageInfo.totalResult,
					param : param
				});
			}
		});
	}

	onChange = (e) => {
		console.log(e);
	};

	submit = (e) => {
		//빈파일이 아닌 경우 함수 진행
		if (this.file.files !== null) {
			//FormData 생성
			const p = new FormData();
			p.append('file', this.file.files[0]);
			p.append('type', this.state.param.type);
			p.append('uploadType', this.state.param.uploadType);
			func.updateFile(this.state.action + 'parse', p).then((response) => {
				if (response.code === 'ok') {

					// func.getData(this.state.action + 'list', this.state.param).then((res) => {
					// 	// console.log(res)
					// 	if(res) {
					// 		this.setState({
					// 			records : res.records,
					// 			totalPage : res.pageInfo.totalPage,
					// 			totalRecords : res.pageInfo.totalResult,
					// 		});
					// 	}
					// });
					location.reload()
					// this.handlePageClick(0)
				} else {
					alert('전산팀에 문의해주세요.')
				}
			});

		}
	}

	handlePageClick = (page) => {
		const paged = page.selected + 1;

		let param = this.state.param;
		param['current_page'] = paged;

		func.getData(this.state.action + 'list', param).then((response) => {
			if(response) {
				this.setState({
					param : param,
					records : response.records,
					totalPage : response.pageInfo.totalPage,
					totalRecords : response.pageInfo.totalResult,
				});
				const url = objectToQueryString(param);
				pushUrl('검색', BASE_PATH + 'wp-admin/admin.php?page=researchmind-import&' + url, this.props.param);
			}
		});
	}

	render() {

		if(!this.state.isInit)
			return ''

		return (
			<>
				<div className="row mt-4 mb-2">
					<div className="col-md-12 form-group">
						<label htmlFor="journal_title"><strong>Wos 논문 반입</strong></label>
						<div className="row">
							<div className="col-md-6">
								<div className="card p-0">
									<div className="card-header">
										반입 포맷
									</div>
									<ul className="list-group list-group-flush">
										{this.state.format.length > 0 &&
											this.state.format.map((data, index) => {
												return (
													<li key={index} className="list-group-item m-0">
														<div className="form-check">
															<input
																className="form-check-input" type="radio" name="exampleRadios"
															  id={"radio" + index} value={data.value} onChange={this.onChange}
																checked={this.state.param.uploadType === data.value}
															/>
															<label className="form-check-label pl-2" htmlFor={"radio" + index}>
																{data.name}
															</label>
														</div>
													</li>
												)
										})}
									</ul>
								</div>
							</div>
							<div className="col-md-6">
								<div className="card p-0">
									<div className="card-header">
										파일 업로드
									</div>
									<div className="card-body">
										<div className="row pl-3 pb-3">
											<input type="file" className="btn btn-sm"
											       ref={(ref) => this.file = ref}
											/>
											<button type="button" className="btn btn-secondary btn-sm ml-2" onClick={this.submit}>업로드</button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<>
							<table className="table table-striped table-thin border-bottom mt-4">
								<colgroup>
									<col width="200px"/>
									<col width="80px"/>
									<col width=""/>
									<col width="80px"/>
									<col width="80px"/>
									<col width="80px"/>
									<col width="150px"/>
									<col width="100px"/>
								</colgroup>
								<thead>
								<tr>
									<th scope="col">작업 ID</th>
									<th scope="col">유형</th>
									<th scope="col">파일명</th>
									<th scope="col">전체</th>
									<th scope="col">중복</th>
									<th scope="col">에러</th>
									<th scope="col">반입일자</th>
									<th scope="col">상태</th>
								</tr>
								</thead>
								<tbody>
								{this.state.isInit &&
								this.state.records.length > 0 ? this.state.records.map((record, index) => {
									return (
										<tr key={record.unique_id}>
											<td><a href={"./admin.php?page=researchmind-import&type="+record.resource_type+"&record_id=" + record.unique_id}>{record.unique_id}</a></td>
											<td>{record.resource_type}</td>
											<td>{record.file_name}</td>
											<td>{record.row_count}</td>
											<td>{record.dup_count}</td>
											<td>{record.err_count}</td>
											<td>{record.input_date}</td>
											<td>{IMPORT_STATUS_NAME[record.progress_status]}</td>
										</tr>
									)
								})
									:
									<tr><td colSpan={8}>결과가 없습니다.</td></tr>
								}
								</tbody>
							</table>
							{this.state.totalPage > 0 &&
							<div className="mt-4">
								<div>
									<div className="paging-wrap">
										<ReactPaginate
											forcePage={Number(this.state.param.current_page) - 1}
											pageCount={this.state.totalPage}
											marginPagesDisplayed={2}
											pageRangeDisplayed={10}
											onPageChange={this.handlePageClick}
											containerClassName={'pagination'}
											activeClassName={'active'}
											pageClassName={'page-item'}
											pageLinkClassName={'page-link'}
											previousClassName={'page-item page-item-prev'}
											previousLinkClassName={'page-link'}
											nextClassName={'page-item page-item-next'}
											nextLinkClassName={'page-link'}
										/>
									</div>
								</div>
							</div>
							}

						</>
					</div>
				</div>
			</>
		)
	}
}

export default WosForm;
